import axios from 'axios';
import router from '@/router';
import notify from '@/util/notify';
import { markAnon } from '@/util/session';

const service = axios.create({
    // timeout: 5000
});

// Note: the interceptor already shows the error to the user, but each call site still needs its own .catch(() => {}),
// otherwise an uncaught Promise rejection makes webpack pop a full-screen error overlay in dev and covers the whole page.
service.interceptors.response.use(
    response => {
        return response;
    }, error => {
        // Network-level errors (timeout, connection reset, aborted request) have no error.response:
        // this used to throw "Cannot read properties of undefined (reading 'status')",
        // masking the real cause (the server still waiting on the CA, or similar)
        if (!error.response) {
            notify.error('The server did not answer in time. Your data is safe — refresh to see the current status.');
            return Promise.reject(error);
        }
        switch (error.response.status) {
            case 400:
                console.error(error)
                notify.error(error.response.data.errorDescription || 'The request was rejected.');
                break;
            case 401: {
                // The cookie is gone or expired: keep the app state honest and send the user to sign in,
                // remembering the page so the login redirects back to it.
                markAnon();
                notify.error('Your session has expired — please sign in again. Your order is kept.');
                const current = router.currentRoute;
                if (current.path !== '/login') {
                    router.replace({ path: '/login', query: { redirect: current.fullPath } });
                }
                break;
            }
            case 403:
                notify.error('You are not allowed to do that.');
                break;
            case 404:
                notify.error('Not found.');
                break;
        }
        if (error.response.status >= 500) {
            notify.error('Server error — please try again in a moment.');
        }
        return Promise.reject(error);
    }
);

export default service;
